// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2101":"4aa19fe2","2276":"55ca27cf","3254":"4aa19fe2","3472":"4aa19fe2","4477":"71de35c0","7345":"4aa19fe2","8539":"1152cf8b"}[chunkId] + ".chunk.css";
};